// extracted by mini-css-extract-plugin
export default {"item":"Item_item__XzkxH","preview":"Item_preview__Qy-rL","title":"Item_title__NOxS8"};